import classOptions from "../classOptions";

export function getTranslationsPage7(newOtherInformation, localizedStrings) {
  // Translate Grade 12 field labels
  newOtherInformation.grade12.usb_classcategory.elementConfig.label = `${localizedStrings.applicationpage.labels.classTitle} *`;
  newOtherInformation.grade12.usb_otherclasscategory.elementConfig.label =
    localizedStrings.applicationpage.labels.addClass;
  newOtherInformation.grade12.usb_level.elementConfig.label = `${localizedStrings.applicationpage.labels.level} *`;
  newOtherInformation.grade12.usb_grade.elementConfig.label = `${localizedStrings.applicationpage.labels.gradewithlabel}`;

  // Update options for usb_level
  newOtherInformation.grade12.usb_level.elementConfig.options =
    newOtherInformation.grade12.usb_level.elementConfig.options.map(
      (option) => {
        if (option.value === "") {
          return {
            ...option,
            displayValue: localizedStrings.applicationpage.selectOption,
          };
        }
        return option;
      },
    );

  const transformClassOptions = (options, localizedStrings) => {
    const localizedMapping = {
      943240000: localizedStrings.applicationpage.classes.advancedMathematics,
      943240001: localizedStrings.applicationpage.classes.appliedMathematics,
      943240002: localizedStrings.applicationpage.classes.canadianLaw,
      943240003: localizedStrings.applicationpage.classes.chemistry,
      943240004: localizedStrings.applicationpage.classes.cinemaModernHistory,
      943240005: localizedStrings.applicationpage.classes.computerScience,
      943240006: localizedStrings.applicationpage.classes.currentTopics,
      943240007: localizedStrings.applicationpage.classes.dance,
      943240008: localizedStrings.applicationpage.classes.dramaticArts,
      943240009: localizedStrings.applicationpage.classes.english,
      943240010: localizedStrings.applicationpage.classes.everydayMathematics,
      943240011: localizedStrings.applicationpage.classes.familyStudies,
      943240035: localizedStrings.applicationpage.classes.french,
      943240012: localizedStrings.applicationpage.classes.frenchsecond,
      943240013: localizedStrings.applicationpage.classes.geography,
      943240014: localizedStrings.applicationpage.classes.globalIssues,
      943240015: localizedStrings.applicationpage.classes.guitar,
      943240016: localizedStrings.applicationpage.classes.harmony,
      943240017: localizedStrings.applicationpage.classes.history,
      943240018: localizedStrings.applicationpage.classes.introCalculus,
      943240019:
        localizedStrings.applicationpage.classes.introCalculusAdvancedMath,
      943240020: localizedStrings.applicationpage.classes.jazz,
      943240021: localizedStrings.applicationpage.classes.leadershipTraining,
      943240022: localizedStrings.applicationpage.classes.music,
      943240023: localizedStrings.applicationpage.classes.biology,
      943240024: localizedStrings.applicationpage.classes.philosophy,
      943240025: localizedStrings.applicationpage.classes.physicalEducation,
      943240026: localizedStrings.applicationpage.classes.physics,
      943240027:
        localizedStrings.applicationpage.classes.preCalculusMathematics,
      943240028: localizedStrings.applicationpage.classes.psychology,
      943240029: localizedStrings.applicationpage.classes.spanish,
      943240030: localizedStrings.applicationpage.classes.textileArtsDesign,
      943240031: localizedStrings.applicationpage.classes.visualArts,
      943240032: localizedStrings.applicationpage.classes.workLifeTransition,
      943240033: localizedStrings.applicationpage.classes.foodNutrition,
      943240034: localizedStrings.applicationpage.classes.other,
    };

    return options.map((option) => ({
      ...option,
      displayValue: localizedMapping[option.value] || option.displayValue,
    }));
  };

  newOtherInformation.grade12.usb_classcategory.elementConfig.options =
    transformClassOptions(classOptions, localizedStrings);

  return newOtherInformation;
}
